import TR from 'utils/TR';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import T from 'utils/T';
import ex from 'utils/ex';
import * as Luxon from 'luxon'
import useFloating from 'hooks/layers/useFloating';
import FocusableButton from 'components/common/FocusableButton';
import usePdfReset from 'hooks/app/usePdfReset';

const FILTER_SELECT_ID = 'FilterSelect';
export default React.forwardRef(function PatientSelectButton(props, outerRef) {
  const {
    category,
  } = props || {};
  const [list, setList] = Recoil.useRecoilState(AppStore.floatings.list('App'));
  const [hash, setHash] = Recoil.useRecoilState(AppStore.floatings.hash('App'));
  const {
    open,
    update,
    close,
  } = useFloating({ setList, setHash });

  const setPatientNo = Recoil.useSetRecoilState(AppStore.assets.patient_no);



  const ref = React.useRef(null);
  React.useImperativeHandle(outerRef, () => ref.current, []);

  const onOuterClick = React.useCallback((ref) => (e) => {
    if (!ref?.current?.contains(e.target)) {
      close(FILTER_SELECT_ID);
    }
  }, [close]);
  const onClose = React.useCallback((e) => {
    close(FILTER_SELECT_ID);
  }, [close]);

  const reset = usePdfReset();
  const onSubmit = React.useCallback((patient_no) => (e) => {
    reset();
    setPatientNo(() => patient_no);
    close(FILTER_SELECT_ID);
  }, [close, reset, setPatientNo]);

  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const patient_list = Recoil.useRecoilValue(AppStore.assets.patient_list);
  const renderer = React.useCallback((patient) => {
    return (
      <>
        <div>{patient?.name}</div>
        <div>{T('{0} | 만 {1}세', patient?.gender, patient?.age)}</div>
      </>
    );
  }, []);

  const floatingInfo = React.useMemo(() => ({
    id: FILTER_SELECT_ID,
    reference: ref,
    placement: 'bottom-right',
    connection: 'none',
    width: 'auto',
    height: 'auto',
    veilable: true,
    stickable: true,
    movable: false,
    closable: false,
    escapable: false,
    modal: true,
    type: FILTER_SELECT_ID,
    events: {
      onOuterClick,
      onClose,
      onSubmit,
    },
    props: {
      item_list: patient_list.map((patient, index) => ({ ...patient, key: patient.patient_no, index })),
      defaultValue: patient_no,
      renderer,
    },
  }), [onClose, onOuterClick, onSubmit, patient_list, patient_no, renderer]);
  const onClick = React.useCallback(() => {
    open(floatingInfo);
  }, [open, floatingInfo]);
  React.useEffect(() => {
    update(floatingInfo)
  }, [floatingInfo, update]);

  return (
    <FocusableButton
      {...ex('PatientSelectButton', props)}
      {...{ ref, onClick }}
    >
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_76_87" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={0} y={0} width={32} height={32}>
          <rect y={32} width={32} height={32} transform="rotate(-90 0 32)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_76_87)">
          <path d="M22.4743 13.3333L15.7372 20L9 13.3333L10.1958 12.15L15.7372 17.6333L21.2785 12.15L22.4743 13.3333Z" fill="#9B9B9B" />
        </g>
      </svg>
    </FocusableButton>
  );
});

